const parseDate = {
    convert: function(unixtime){
        return new Date(unixtime * 1000);
    },
    months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    day: function(date){
        date = `0${date}`;
        date = date.split("");
        if(date.length > 2){
            delete date[0];
        }
        return date.join("");
    },
    full: function( unixtime ){

        var time = this.convert( unixtime );
        return `${this.months[time.getMonth()]}-${this.day(time.getDate())}-${time.getFullYear()} | ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`
    },
    onlytime: function(unixtime){
        var time = this.convert( unixtime );
        return `${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
    onlydate: function(unixtime, format){
        var time = this.convert( unixtime );

        format = format || "d-m-Y";
        var date = {
            Y: time.getFullYear(),
            m: this.months[time.getMonth()],
            d: this.day(time.getDate()),
        };
        format = format.split("-");
        var getDate = [];
        format.map(function( data ){
            if(typeof date[data] === "undefined"){
                console.warn("undefined "+data+" date value.")
                return;
            }
            getDate.push(date[data])
        })
        return getDate.join("-");
    }
}

export {parseDate};